import * as R from 'ramda'

export const isValidSubscriberCount = (key) =>
  R.compose(hasCountMoreThanZero, R.prop(key))

export const hasCountMoreThanZero = R.compose(
  R.not,
  R.anyPass([R.isNil, R.isEmpty, R.lte(R.__, 0)]),
)
